import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import themes from '@bitcoin-portal/bitcoincom-pkg-theme';
import { GlobalStyle } from './styled';
import Intl from '../../i18n/hoc';
import SEO from './SEO';
import { initAmplitude } from '../../helpers/analytics';

const providerTheme = themes.light;

const Layout = props => {
  const { localeDir, children, locale, netlify } = props;

  useEffect(() => {
    initAmplitude();
  }, []);

  return (
    <Intl locale={locale} localeDir={localeDir} netlify={netlify}>
      <ThemeProvider theme={providerTheme}>
        <>
          <SEO />
          <GlobalStyle />
          {children}
        </>
      </ThemeProvider>
    </Intl>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  locale: PropTypes.string.isRequired,
  localeDir: PropTypes.string.isRequired,
  netlify: PropTypes.shape({}),
};

Layout.defaultProps = {
  netlify: undefined,
};

export default Layout;
